module.exports = __webpack_public_path__ + "img/gb974.prt.65018e07.jpg";